"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conversationReducer = conversationReducer;
exports.initialConversationState = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialConversationState = exports.initialConversationState = {
  screen: "welcome",
  // welcome | ai | contact | group | task
  conversation: null,
  // normalized Conversation, see core/types.js
  requireResponseChatIds: [],
  isUnreadActive: false
};
function conversationReducer(state, action) {
  switch (action.type) {
    case "SELECT_CONVERSATION":
      return _objectSpread(_objectSpread({}, state), {}, {
        screen: action.conversation.kind,
        conversation: action.conversation
      });
    case "SET_SCREEN":
      return _objectSpread(_objectSpread({}, state), {}, {
        screen: action.screen
      });
    case "UPDATE_GROUP_META":
      return state.conversation ? _objectSpread(_objectSpread({}, state), {}, {
        conversation: _objectSpread(_objectSpread({}, state.conversation), {}, {
          group: _objectSpread(_objectSpread({}, state.conversation.group), action.patch)
        })
      }) : state;
    case "SET_REQUIRE_RESPONSE_IDS":
      return _objectSpread(_objectSpread({}, state), {}, {
        requireResponseChatIds: action.ids
      });
    case "SET_UNREAD_ACTIVE":
      return _objectSpread(_objectSpread({}, state), {}, {
        isUnreadActive: action.value
      });
    case "RESET":
      return _objectSpread({}, initialConversationState);
    default:
      return state;
  }
}